/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Scope_OrganisationInputs */



/**
* | output |
* | --- |
* | "For the whole organisation" |
*
* @param {Settings_Template_Scope_OrganisationInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_scope_organisation = /** @type {((inputs?: Settings_Template_Scope_OrganisationInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Scope_OrganisationInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voor de hele organisatie")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour toute l'organisation")
	return /** @type {LocalizedString} */ ("For the whole organisation")
});